// @ts-nocheck
import React from 'react'
import { Card, CardHeader, CardText, CardTitle } from 'material-ui/Card'
import { Table, TableBody, TableRow, TableRowColumn } from 'material-ui/Table'
import {
  ImageLooksOne,
  ImageLooksTwo,
  ImageLooks3
} from 'material-ui/svg-icons'

import Spacer from '../spacer'
import DownloadLink from './downloadFile'
import FileInput from '../file-input'
import get from 'lodash/get'
import ClearIcon from 'material-ui/svg-icons/content/clear'
import RaisedButton from 'material-ui/RaisedButton'
import api from '../../api'
import { connect } from 'react-redux'
import { setSnackbarMessage } from '../../actions/snackbar'
import { styles } from './styles'
import Alert from './alert'

const initialState = {
  step: 1,
  file: null,
  result: null,
  openCardIndex: -1,
  verifyData: null,
  previousAction: null,
  previousMessage: null,
  uploading: false
}

class MemberImport extends React.Component<any, any> {
  constructor (props) {
    super(props)
    // Clone Initial State
    this.state = Object.assign({}, initialState)
  }

  // Handles file selection in Step 1
  handleFileSelection = (file) => {
    this.setState({ file })
  };

  // Handle Final Submission
  handleFinalSubmit = () => {
    this.setState({
      uploading: true
    })
    api
      .post('admin/users/member_import/json', {
        body: {
          filename: this.state.verifyData.filename,
          data: this.state.verifyData.data
        }
      })
      .then((res) => {
        const fileName = this.state.verifyData.filename

        if (!res || res.status > 400 || !res.ok) {
          this.setState(initialState)
          this.setState({
            previousAction: 'error',
            previousMessage: `The upload for ${fileName} has been canceled.`
          })
        } else {
          res.json().then((data) => {
            if (data.errors.length) {
              this.setState(initialState)
              this.setState({
                previousAction: 'error',
                previousMessage: `The file ${fileName} has failed to upload. See log history for details.`
              })
            } else {
              this.setState(initialState)
              this.setState({
                previousAction: 'success',
                previousMessage: `The file ${fileName} has been uploaded successfully.`
              })
            }
          })
        }
      })
      .catch(() => {
        this.setState(initialState)
        this.setState({
          previousAction: 'error',
          previousMessage: 'The upload has been canceled.'
        })
      })
      .finally(() => {
        this.setState({
          uploading: false
        })
      })
  };

  // Handles verify submit in Step 1
  handleVerifySubmit = () => {
    const formData = new window.FormData()
    formData.append('file', this.state.file, this.state.file.name)

    api
      .postFile('admin/users/member_import/verify', { body: formData })
      .then((res) => {
        if (!res || res.status > 400 || !res.ok) {
          this.props.setSnackbarMessage(
            'Something went wrong with uploading. Please try again.'
          )
          this.clearFile()
        } else {
          res.json().then((data) => {
            this.setState({
              verifyData: data
            })
            this.nextStep()
          })
        }
      })
      .catch(() => {
        this.props.setSnackbarMessage(
          'Something went wrong with uploading. Please try again.'
        )
        this.clearFile()
      })
  };

  // Proceed to next step
  nextStep = () => {
    const { step } = this.state
    let nextStep = step + 1

    switch (step) {
      case 1:
        if (
          !this.state.verifyData.result.newInstitutionsToBeCreated.length &&
          !this.state.verifyData.result.deletedUsers.length
        ) {
          if (this.state.verifyData.errors.length) {
            nextStep = 3
          } else {
            return this.handleFinalSubmit()
          }
        }
        break
      case 2:
        if (!this.state.verifyData.errors.length) { return this.handleFinalSubmit() }
        break
    }
    this.setState({
      step: nextStep
    })
  };

  // Proceed to previous step
  prevStep = () => {
    const fileName = this.state.verifyData.filename
    this.setState(initialState)
    this.setState({
      previousAction: 'error',
      previousMessage: `The upload for ${fileName} has been canceled.`
    })
  };

  // Clear File Upload
  clearFile = () => {
    this.setState({
      file: null
    })
  };

  // Step 1
  step1 () {
    return (
      <div>
        {this.state.previousAction && this.state.previousMessage && (
          <div style={{ paddingTop: '25px' }}>
            <Alert
              message={this.state.previousMessage}
              type={this.state.previousAction}
            />
          </div>
        )}
        <CardTitle title='Import Member Data' style={{ paddingLeft: 0 }} />
        <div>
          <p>
            This screen will allow you to import member data – including users,
            institutions, and memberships – into the system. Before you get
            started, take some time to review how to set up a data file and then
            how to import the data.
          </p>
        </div>
        <Spacer />
        <Card
          expandable
          initiallyExpanded={false}
          onExpandChange={() => {
            this.setState({
              openCardIndex: this.state.openCardIndex === 0 ? 1 : 0
            })
          }}
          expanded={this.state.openCardIndex === 0}
        >
          <CardHeader
            title='Setting Up a Data File'
            actAsExpander
            showExpandableButton
            style={styles.header}
          />

          <CardText expandable>
            <div>
              <span style={styles.headerText}>
                Max Users in Single Upload File:
              </span>{' '}
              10,000
            </div>
            <div style={styles.italicText}>
              Please note that if you receive a "Failed to Fetch" error message,
              please wait 10-15 minutes and check the Log History to confirm
              that the process did not continue forward and succeed.
            </div>
            <Spacer />
            <div style={styles.headerText}>
              Relating to Dates and Microsoft Excel
            </div>
            <div style={styles.italicText}>
              Please format all dates in ISO-8601 format (link to Wikipedia).
              You can copy-paste the following into Excel:
              2022-08-09T12:50:00-04:00 (YYYY-MM-DDTHH:MM:SS-04:00). Be aware
              that Excel will overwrite this format if it only includes the
              date.
            </div>
            <Spacer />
            <span style={styles.headerText}>
              Before you upload, you will need to set up a CSV file:
            </span>
            <ol>
              <li type='1'>
                <DownloadLink templatePath='admin/users/member_import/template' />
              </li>
              <li type='2'>
                Each row in the spreadsheet represents a user record. Each user
                record is uniquely identified by its email address.
              </li>
              <li type='3'>
                Add or update a user record by first entering the email address,
                then completing the remaining columns in the row as needed.
                <ul style={styles.disc}>
                  <li>
                    Use the second column – "member_type" – to assign a user who
                    belongs to an institution as a sub-account (enter
                    "subaccount" into the spreadsheet) or as an account holder
                    (enter "mah" into the spreadsheet).
                  </li>
                  <li>
                    Use the fourth column – "institution_name" to indicate the
                    institution that the member belongs to.
                  </li>
                  <li>
                    Use the optional "school_or_college" column to set the
                    member's School or College. The value must exactly match
                    (case-insensitive) one of the Schools/Colleges already set
                    up for that member's institution, or be "Not Listed" to
                    indicate the member's school/college isn't in that list;
                    unmatched values will fail with an error.
                  </li>
                  <li style={styles.noBullet}>
                    NOTE: Be sure to check if the institution already exists in
                    the system – if so, enter this name exactly into the
                    spreadsheet. If you create a new institution name in the
                    spreadsheet, it will trigger the creation of a new
                    institution record.
                  </li>
                </ul>
              </li>
              <li type='4'>
                Continue adding user records as additional rows in the
                spreadsheet as needed.
              </li>
              <li type='5'>
                Before you save the file, check your entries for any errors:
              </li>
              <ul style={styles.disc}>
                <li>
                  Email addresses should be in the format name@domain.ext.
                </li>
                <li>
                  Ensure that the member type uses the appropriate codes – "mah"
                  and "subaccount" as discussed above.
                </li>
                <li>
                  Ensure that phone numbers consist of 10 digits with no letters
                  or trailing spaces or other characters.
                </li>
              </ul>
              <li type='6'>
                Save your file in CSV format. (not in Excel format, or any other
                format).
              </li>
            </ol>
          </CardText>
        </Card>

        <Card
          expandable
          initiallyExpanded={false}
          expanded={this.state.openCardIndex === 1}
          onExpandChange={() => {
            this.setState({
              openCardIndex: this.state.openCardIndex === 1 ? 0 : 1
            })
          }}
        >
          <CardHeader
            style={styles.header}
            title='The Data Import Process'
            actAsExpander
            showExpandableButton
          />
          <CardText expandable>
            <span>
              Here is a quick overview of how the data import process works.
            </span>
            <Spacer />
            <Spacer />
            <Table>
              <TableBody displayRowCheckbox={false}>
                <TableRow style={{ borderBottom: 'none' }}>
                  <TableRowColumn>
                    <ImageLooksOne style={styles.stepIcon} />{' '}
                    <span style={styles.stepText}>Upload Your File</span>
                  </TableRowColumn>
                  <TableRowColumn>
                    <ImageLooksTwo style={styles.stepIcon} />{' '}
                    <span style={styles.stepText}>Verify Data Records</span>
                  </TableRowColumn>
                  <TableRowColumn>
                    <ImageLooks3 style={styles.stepIcon} />{' '}
                    <span style={styles.stepText}>Correct Format Errors</span>
                  </TableRowColumn>
                </TableRow>
                <TableRow style={{ verticalAlign: 'top' }}>
                  <TableRowColumn style={styles.tableRowCol}>
                    Select your csv file or select the file from your local
                    drive.{' '}
                  </TableRowColumn>
                  <TableRowColumn style={styles.tableRowCol}>
                    If the system detects that the file contains a new
                    institution record or an email address belonging to a
                    previously deleted user, you will be asked to verify if
                    these records should be created or restored.{' '}
                  </TableRowColumn>
                  <TableRowColumn style={styles.tableRowCol}>
                    If the system detects any format errors in the data, you
                    will be prompted to correct these errors.{' '}
                  </TableRowColumn>
                </TableRow>
              </TableBody>
            </Table>
          </CardText>
        </Card>
        <Spacer />
        <div style={styles.steps}>Step 1 of 3</div>
        <div style={styles.uploadYourFileHeader}>Upload Your File</div>
        <div style={{ marginTop: '30px' }}>
          <FileInput
            accept='text/csv'
            label='BROWSE FILES'
            onFileSelected={this.handleFileSelection}
          />
        </div>
        <div style={{ marginTop: '15px' }}>
          <span style={styles.steps}>
            Max size: 50 MB, file type: CSV, only one file can be uploaded at a
            time.
          </span>
        </div>
        {this.state.file && (
          <div>
            <div style={styles.fileList}>
              <span style={styles.fileListText}>
                {get(this.state.file, 'name')}
              </span>
              <ClearIcon style={styles.fileListIcon} onClick={this.clearFile} />
            </div>
            <div>
              <Spacer />
              <Spacer />
              <RaisedButton
                label='Continue'
                disabled={this.state.uploading}
                primary
                onClick={this.handleVerifySubmit} // this should lead us to Step 2 -- verify data page.
              />
            </div>
          </div>
        )}
        <Spacer />
      </div>
    )
  }

  // Step 2
  step2 () {
    return (
      <div>
        <p style={styles.steps}>Step 2 of 3</p>
        <span style={styles.fileName}>{this.state.verifyData.filename}</span>
        <div style={styles.header2}>Verify Data Records</div>
        <Spacer />

        {/* New Institutions  */}
        {this.state.verifyData.result.newInstitutionsToBeCreated.length > 0 && (
          <div>
            <span style={styles.title}>New Institution Detected</span>
            <div style={styles.text}>
              The following institution(s) are not currently in our system:
            </div>
            <Card style={styles.card}>
              <CardHeader
                style={styles.border}
                title=''
                subtitle={
                  'The list of new institutions (' +
                  this.state.verifyData.result.newInstitutionsToBeCreated
                    .length +
                ')'
                }
                actAsExpander
                showExpandableButton
              />
              <CardText expandable>
                <ul style={styles.list}>
                  {this.state.verifyData.result.newInstitutionsToBeCreated.map(
                    (value, key) => (
                      <li key={key}>{value}</li>
                    )
                  )}
                </ul>
              </CardText>
            </Card>
            <Spacer />
            <Spacer />
          </div>
        )}

        {/* New Users */}
        {this.state.verifyData.result.deletedUsers.length > 0 && (
          <div>
            <span style={styles.title}>Deleted User Detected</span>
            <div style={styles.text}>
              The following email addresses are associated with users who have
              been deleted from the system.
            </div>
            <Card style={styles.card}>
              <CardHeader
                style={styles.border}
                title=''
                subtitle={
                  'The list of user email addresses (' +
                  this.state.verifyData.result.deletedUsers.length +
                ')'
                }
                actAsExpander
                showExpandableButton
              />
              <CardText expandable>
                <ul style={styles.list}>
                  {this.state.verifyData.result.deletedUsers.map(
                    (value, key) => (
                      <li key={key}>{value}</li>
                    )
                  )}
                </ul>
              </CardText>
            </Card>
            <Spacer />
            <Spacer />
          </div>
        )}

        <div style={styles.muted}>
          If you click Continue, we will proceed by creating and restoring all
          of the above.
        </div>
        <Spacer />
        <div>
          <RaisedButton
            label='Cancel'
            style={{ marginRight: '20px' }}
            onClick={this.prevStep}
          />
          <RaisedButton
            label='Continue'
            disabled={this.state.uploading}
            primary
            onClick={this.nextStep}
          />
        </div>
      </div>
    )
  }

  // Step 3
  step3 () {
    return (
      <div>
        <p style={styles.steps}>Step 3 of 3</p>
        <span style={styles.fileName}>{this.state.verifyData.filename}</span>
        <div style={styles.header2}>Correct Format Errors</div>
        <Spacer />

        <div style={styles.text}>
          <div>
            We have detected the following format errors in the file. Please
            correct the data where indicated. Once you submit the file, any rows
            that still contain errors will be deleted.
          </div>
          <Spacer />
          <div>Here is the guidance for the correct format:</div>
          <ul>
            <li>Email addresses should be in the format name@domain.ext.</li>
            <li>
              Ensure that the member type uses the appropriate codes – "mah" and
              "subaccount" as discussed above.
            </li>
            <li>
              Ensure that phone numbers consist of 10 digits with no letters or
              trailing spaces or other characters.
            </li>
          </ul>
        </div>
        <Spacer />
        <Alert
          message={
            'There are ' +
            this.state.verifyData.errors.length +
          ' error(s) in this file.  Please cancel, fix the errors, and start the upload process again.'
          }
          type='error'
        />
        <Spacer />
        <Card style={styles.errorCard} initiallyExpanded>
          <CardHeader
            style={styles.errorCardHeader}
            title='The Error List'
            actAsExpander
            showExpandableButton
          />
          <CardText expandable>
            <ul style={styles.errorList}>
              {this.state.verifyData.errors.map((value, key) => (
                <li style={styles.errorListItem} key={key}>
                  Line: {value.line}:{' '}
                  <span dangerouslySetInnerHTML={{ __html: value.message }} />
                </li>
              ))}
            </ul>
          </CardText>
        </Card>

        <Spacer />
        <Spacer />
        <div>
          <RaisedButton label='Cancel' onClick={this.prevStep} />
        </div>
      </div>
    )
  }

  // Default
  render () {
    switch (this.state.step) {
      case 1:
        return this.step1()
      case 2:
        return this.step2()
      case 3:
        return this.step3()
    }
  }
}

export default connect(null, { setSnackbarMessage })(MemberImport)
